'use strict';
import * as $j_app$002edata$002e$002dSend$002dEmail$002dSign$002dIn$002dLink$002dError$0024$0024anon$00241 from "./app.data.-Send-Email-Sign-In-Link-Error$$anon$1.js";
import * as $j_app$002edata$002e$002dSend$002dEmail$002dSign$002dIn$002dLink$002dError$0024$002dOther from "./app.data.-Send-Email-Sign-In-Link-Error$-Other.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $s_Lapp_data_SendEmailSignInLinkError$__QuotaExceeded__Lapp_data_SendEmailSignInLinkError() {
  $m_Lapp_data_SendEmailSignInLinkError$();
  return $t_Lapp_data_SendEmailSignInLinkError$__QuotaExceeded;
}
export { $s_Lapp_data_SendEmailSignInLinkError$__QuotaExceeded__Lapp_data_SendEmailSignInLinkError as $s_Lapp_data_SendEmailSignInLinkError$__QuotaExceeded__Lapp_data_SendEmailSignInLinkError };
function $s_Lapp_data_SendEmailSignInLinkError$__InvalidEmail__Lapp_data_SendEmailSignInLinkError() {
  $m_Lapp_data_SendEmailSignInLinkError$();
  return $t_Lapp_data_SendEmailSignInLinkError$__InvalidEmail;
}
export { $s_Lapp_data_SendEmailSignInLinkError$__InvalidEmail__Lapp_data_SendEmailSignInLinkError as $s_Lapp_data_SendEmailSignInLinkError$__InvalidEmail__Lapp_data_SendEmailSignInLinkError };
/** @constructor */
function $c_Lapp_data_SendEmailSignInLinkError$() {
  $n_Lapp_data_SendEmailSignInLinkError$ = this;
  $t_Lapp_data_SendEmailSignInLinkError$__QuotaExceeded = new $j_app$002edata$002e$002dSend$002dEmail$002dSign$002dIn$002dLink$002dError$0024$0024anon$00241.$c_Lapp_data_SendEmailSignInLinkError$$anon$1("QuotaExceeded", 0);
  $t_Lapp_data_SendEmailSignInLinkError$__InvalidEmail = new $j_app$002edata$002e$002dSend$002dEmail$002dSign$002dIn$002dLink$002dError$0024$0024anon$00241.$c_Lapp_data_SendEmailSignInLinkError$$anon$1("InvalidEmail", 1);
}
export { $c_Lapp_data_SendEmailSignInLinkError$ as $c_Lapp_data_SendEmailSignInLinkError$ };
$p = $c_Lapp_data_SendEmailSignInLinkError$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_SendEmailSignInLinkError$;
/** @constructor */
function $h_Lapp_data_SendEmailSignInLinkError$() {
}
export { $h_Lapp_data_SendEmailSignInLinkError$ as $h_Lapp_data_SendEmailSignInLinkError$ };
$h_Lapp_data_SendEmailSignInLinkError$.prototype = $p;
$p.bJc = (function(err) {
  var msg = err.gw();
  return (((msg.indexOf("auth/quota-exceeded") | 0) !== (-1)) ? $s_Lapp_data_SendEmailSignInLinkError$__QuotaExceeded__Lapp_data_SendEmailSignInLinkError() : (((msg.indexOf("auth/invalid-email") | 0) !== (-1)) ? $s_Lapp_data_SendEmailSignInLinkError$__InvalidEmail__Lapp_data_SendEmailSignInLinkError() : new $j_app$002edata$002e$002dSend$002dEmail$002dSign$002dIn$002dLink$002dError$0024$002dOther.$c_Lapp_data_SendEmailSignInLinkError$Other($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_ThrowableExts$package$().a56(err))));
});
$p.dl = (function(x) {
  return x.co();
});
var $d_Lapp_data_SendEmailSignInLinkError$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_SendEmailSignInLinkError$, "app.data.SendEmailSignInLinkError$", ({
  F5: 1,
  d: 1,
  D: 1
}));
export { $d_Lapp_data_SendEmailSignInLinkError$ as $d_Lapp_data_SendEmailSignInLinkError$ };
var $n_Lapp_data_SendEmailSignInLinkError$;
function $m_Lapp_data_SendEmailSignInLinkError$() {
  if ((!$n_Lapp_data_SendEmailSignInLinkError$)) {
    $n_Lapp_data_SendEmailSignInLinkError$ = new $c_Lapp_data_SendEmailSignInLinkError$();
  }
  return $n_Lapp_data_SendEmailSignInLinkError$;
}
export { $m_Lapp_data_SendEmailSignInLinkError$ as $m_Lapp_data_SendEmailSignInLinkError$ };
var $t_Lapp_data_SendEmailSignInLinkError$__QuotaExceeded = null;
function $u_Lapp_data_SendEmailSignInLinkError$__QuotaExceeded(x) {
  $t_Lapp_data_SendEmailSignInLinkError$__QuotaExceeded = x;
}
export { $t_Lapp_data_SendEmailSignInLinkError$__QuotaExceeded as $t_Lapp_data_SendEmailSignInLinkError$__QuotaExceeded, $u_Lapp_data_SendEmailSignInLinkError$__QuotaExceeded as $u_Lapp_data_SendEmailSignInLinkError$__QuotaExceeded };
var $t_Lapp_data_SendEmailSignInLinkError$__InvalidEmail = null;
function $u_Lapp_data_SendEmailSignInLinkError$__InvalidEmail(x) {
  $t_Lapp_data_SendEmailSignInLinkError$__InvalidEmail = x;
}
export { $t_Lapp_data_SendEmailSignInLinkError$__InvalidEmail as $t_Lapp_data_SendEmailSignInLinkError$__InvalidEmail, $u_Lapp_data_SendEmailSignInLinkError$__InvalidEmail as $u_Lapp_data_SendEmailSignInLinkError$__InvalidEmail };
//# sourceMappingURL=app.data.-Send-Email-Sign-In-Link-Error$.js.map
